<script>
	import EditFontTheme from "../../../components/EditFontTheme.svelte";
	import EditColorTheme from "../../../components/EditColorTheme.svelte";
	import ButtonSave from "../../../components/ButtonSave.svelte";
	import {
		organizationProjectSettings,
		fetchOrganizationProjectSettings,
		colorthemes,
		selectedProjectObj,
		selectedOrganizationObj,
	} from "../../../stores";

	$: settings = $organizationProjectSettings;

	let modified = {};
	$: settings && (modified = { fonttheme: settings.font_theme.modified, colortheme: settings.color_theme.modified });

	const saveOrganizationProjectSettings = async (fonttheme, colortheme) => {
		await api.patch(`organisationProjectSettings/${settings.id}/`, {
			font_theme: fonttheme.selected,
			color_theme: colortheme.selected,
		});

		fetchOrganizationProjectSettings();
		modified = {};
	};
</script>

<main class="site">
	{#if settings}
		<div class="container">
			<h4>Project Settings</h4>
			<h5 class="subheading">
				for
				<strong>{$selectedProjectObj.name}</strong>
				for
				<strong>{$selectedOrganizationObj.name}</strong>
			</h5>
			<div class="fonts">
				<h5>Font Theme</h5>
				<EditFontTheme
					noSelection={true}
					noSelectionLabel={"No project font theme"}
					bind:selected={settings.font_theme.selected}
					bind:modified={settings.font_theme.modified}
					{...settings.font_theme}
				/>
			</div>
			{#if $colorthemes.length > 0}
				<div class="colors">
					<h5>Color Theme</h5>
					<EditColorTheme
						bind:selected={settings.color_theme.selected}
						bind:modified={settings.color_theme.modified}
						{...settings.color_theme}
					/>
				</div>
			{/if}
			<div class="button-container">
				<ButtonSave
					{modified}
					on:click={() => saveOrganizationProjectSettings(settings.font_theme, settings.color_theme)}
				/>
			</div>
		</div>
	{/if}
</main>

<style lang="scss">
	main {
		overflow: scroll;
		padding: 16px;
		height: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		width: 100%;
	}

	.container {
		flex-grow: 1;
		max-width: 800px;
	}

	.button-container {
		display: flex;
		justify-content: flex-end;
		margin-top: 30px;
		gap: 30px;
	}

	.subheading {
		margin-top: 0px;
	}
</style>
